module.exports = __webpack_public_path__ + "static/media/Slide3.1fa07da2.JPG";